/// <reference path="Utilities/_reference.ts" />

module YVR.FlightNotification {
	// Dependencies
	import flights = YVR.Utilities.Flights;
	import logger = YVR.Utilities.Logger;

	// CSS Classes
	const classes = {
		loading: 'yvr-flight-notification--loading'
	};

	// Cached jQuery elements
	const elements = {
		flightNotificationTypes: $('input[name="SubscribeType"]'),
		emailAddressRow: $('.yvr-form__row[data-form-field="email"]'),
		phoneNumberRow: $('.yvr-form__row[data-form-field="sms"]'),
		emailAddress: $('#yvr-flight-notification-address-email'),
		phoneNumber: $('#yvr-flight-notification-address-sms'),
		flightId: $('#yvr-flight-notification-flightid'),
		flightInfo: $('#yvr-flight-notification-info')
	};


	function main() {
		if (window.location.href.toLowerCase().includes('flight-notifications')) {
			console.log('flight-notifications.ts');
			getFlightInfo();
			eventFlightNotificationTypeBindings();
			changeFlightNotificationType();
			addAriaLabel();
			focusViewEarlierButton();
			notifyButtonAria();
		}

	}

	//#region  FlightNotification

	function getFlightInfo() {
		if (elements.flightInfo.length) {
			elements.flightInfo.addClass(classes.loading);

			let id = elements.flightId.val();

			flights.getFlightByFlightId(id)
				.then(renderFlightDetails)
				.fail(() => {
					logger.error('[flight-notification][getFlightInfo] An error occured retrieving the flight data.');
				});

		}
	}


	/**
	 * Render the flight detail data from the gateway wrapper.
	 * @param {obj} data The data returned from the gateway wrapper.
	 */
	function renderFlightDetails(data: IFlightCollection) {
		if (data && data.value && data.value.length) {
			//const source = $('#yvr-flights-template').html();
			//const template = Handlebars.compile(source);

			let template = null;

			if (document.documentElement.lang === "fr") {
				template = YVR.templates.flightCardFR;
			} else {
				template = YVR.templates.flightCardEN;
			}

			const html = template({ flights: data.value });
			$('#yvr-flight-notification-info').html(html);
		}
	}


	/**
	 * Set any event bindings necessary for this component
	 */
	function eventFlightNotificationTypeBindings() {
		elements.flightNotificationTypes.on('change', changeFlightNotificationType);
	}


	/**
	 * Change the email address or SMS inputs based on the selected setting.
	 */
	function changeFlightNotificationType() {
		const value = elements.flightNotificationTypes.filter(':checked').val();

		if (value === 'email') {
			elements.phoneNumberRow.hide();
			elements.phoneNumber.attr('disabled', 'disabled');

			elements.emailAddressRow.show();
			elements.emailAddress.removeAttr('disabled');
		}

		if (value === 'sms') {
			elements.emailAddressRow.hide();
			elements.emailAddress.attr('disabled', 'disabled');

			elements.phoneNumberRow.show();
			elements.phoneNumber.removeAttr('disabled');
		}
	}

	//#endregion

	// Adds an Aria-Label to the Estimate column
	function addAriaLabel() {

		window.addEventListener('load', function () {

			const labelRevised = document.getElementsByClassName('yvr-flights__revised-label');

			for (let i = 0; i < labelRevised.length; i++) {

				let ariaLabel = labelRevised[i].classList.item(2).split('--').pop();

				if (ariaLabel === 'str_on_time') {

					ariaLabel = 'on time';

				}

				labelRevised[i].setAttribute('aria-label', ariaLabel);

			}

		});

	}


	// Focus the tab to h1 tag after user clicks "View Earlier Flights" button
	function focusViewEarlierButton() {

		window.addEventListener('load', function () {

			const viewEarlierButton = document.getElementsByClassName('yvr-flights__button--view-earlier')[0];

			viewEarlierButton.addEventListener('click', function () {

				document.getElementsByTagName('h1')[0].focus();

			});

		});

	}

	// Add an aria-label that says "Notify me about (flight number)" on Notify me buttons
	function notifyButtonAria() {

		window.addEventListener('load', function () {

			const yvrFlightsNotif = document.getElementsByClassName('yvr-flights__notification');

			for (let i = 0; i < yvrFlightsNotif.length; i++) {

				yvrFlightsNotif[i].setAttribute('aria-label', 'Notify me about flight number ' + yvrFlightsNotif[i].parentElement.parentElement.children[2].innerHTML);

			}

		});

	}



	main();
}
